import { Link } from 'react-router-dom'
import { useCart } from '../lib/store'

/**
 * The one confirmation the whole store uses after an add to bag. It sits above
 * the page, announces itself to screen readers, and re-keys on every add so a
 * repeat press restarts the animation rather than looking like nothing moved.
 */
export function CartToast() {
  const { toast, count, dismissToast } = useCart()

  return (
    <div className="toast-region" role="status" aria-live="polite">
      {toast && (
        <div key={toast.id} className={`toast${toast.kind === 'duplicate' ? ' toast-dup' : ''}`}>
          <span className="toast-mark" aria-hidden="true">
            {toast.kind === 'added' ? (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="m5 12.5 4.5 4.5L19 7.5" />
              </svg>
            ) : (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M12 7.5v5.5" />
                <path d="M12 16.4v.1" />
              </svg>
            )}
          </span>

          <div className="toast-body">
            <div className="toast-title">{toast.title}</div>
            <div className="toast-detail">{toast.detail}</div>
            <Link to="/cart" onClick={dismissToast} className="toast-link">
              View bag ({count}) →
            </Link>
          </div>

          <button type="button" className="toast-close" onClick={dismissToast} aria-label="Dismiss notification">
            ×
          </button>
        </div>
      )}
    </div>
  )
}
